import { ReactNode } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppHeader } from "./AppHeader";
import { MobileBottomNav } from "./MobileBottomNav";
import { useIsMobile } from "@/hooks/use-mobile";
import { AdminModeProvider } from "@/hooks/useAdminMode";
import { FloatingCalculator } from "@/components/dashboard/FloatingCalculator";
import { ProfileCompletionBanner } from "@/components/settings/ProfileCompletionBanner";
import { ForceProfileModal } from "@/components/settings/ForceProfileModal";
import { SubscriptionBanner } from "@/components/subscription/SubscriptionBanner";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <AdminModeProvider>
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          {/* Hide sidebar on mobile, show on tablet/desktop */}
          <div className="hidden md:block">
            <AppSidebar />
          </div>
          <SidebarInset className="flex flex-1 flex-col">
            <AppHeader />
            <main className="flex-1 overflow-auto p-4 md:p-6 pb-20 md:pb-6">
              <SubscriptionBanner />
              {children}
            </main>
          </SidebarInset>
        </div>
        
        {/* Mobile bottom navigation */}
        {isMobile && <MobileBottomNav />}
        
        {/* Global Floating Calculator - available on all pages */}
        <FloatingCalculator />
        
        {/* Profile Completion Banner - shows until profile is 100% complete */}
        <ProfileCompletionBanner />
        
        {/* Force Profile Completion Modal - appears every 30 min if incomplete */}
        <ForceProfileModal />
      </SidebarProvider>
    </AdminModeProvider>
  );
}
